import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { IS_SP } from '~/const/config';
// import { IS_SP, IS_PORTRAIT } from '~/const/config';

export class ShowMonitor {
  constructor() {
    this.DOM = {};
    this.DOM.monitor = document.querySelector('.js-monitor');

    if (!this.DOM.monitor) return;

    this.onInit();
  }
  /**
   * 初期化
   */
  onInit() {
    this._setScrollTrigger();
  }
  /**
   * スクロールトリガーのセット
   */
  _setScrollTrigger() {

    gsap.to(this.DOM.monitor,{
      scrollTrigger: {
        trigger: this.DOM.monitor,
        start: (IS_SP) ? 'top center' : 'top-=50% center',
        fastScrollEnd: true,
        // markers: true,
        onEnter: () => {
          this.DOM.monitor.classList.add('is-show');
        }
      }
    });
  }
}
